import React, { useContext, useMemo } from 'react';
import './_report-services-table.dark-mode.scss'
import './_report-services-table.scss'
import ServicesTableBody from './Body';
import ServicesTableHeader from './Header';
import ServicesTableFooter from './Footer';
import { ServicesReportsContext } from '../..';
import Loader from '../../../../../components/Loaders/Loader';
import { sortData } from '../../helpers';

const ServicesTable = () => {
  const [state] = useContext(ServicesReportsContext);
  const { data, sort, filters, isLoading } = state;

  const dataSorted = useMemo(() => sortData(data, sort), [data, sort]);

  return (
    <div className="reports-services-table">
      {isLoading ? <Loader /> : null }
      <ServicesTableHeader />
      <ServicesTableBody data={dataSorted} isLoading={isLoading} filters={filters} />
      <ServicesTableFooter data={data} />
    </div>
  );
}

ServicesTable.propTypes = {

};

export default ServicesTable;
